module.exports = __webpack_public_path__ + "static/media/SplashScreen.74cc15c1.png";